import { render, staticRenderFns } from "./ConfirmReservation.vue?vue&type=template&id=0ff6eb76&"
import script from "./ConfirmReservation.vue?vue&type=script&lang=js&"
export * from "./ConfirmReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports